import {OperationVariables} from "@apollo/react-common"
import {DataProxy} from "apollo-cache"

export const readQuery = <TQuery, TVariables = OperationVariables>(
    cache: DataProxy,
    options: DataProxy.Query<TVariables>,
    optimistic?: boolean,
): TQuery | null => {
    try {
        return cache.readQuery<TQuery, TVariables>(options, optimistic)
    } catch {
        return null
    }
}
